import { render, staticRenderFns } from "./learningGarden.vue?vue&type=template&id=e05c374e&"
import script from "./learningGarden.vue?vue&type=script&lang=js&"
export * from "./learningGarden.vue?vue&type=script&lang=js&"
import style0 from "./learningGarden.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports